import getDayName from './get-day-name';

export { getDayName };

export default getDayName;
